module.exports = __webpack_public_path__ + "resources/img/ico_required.370a2d37286951b9b79c75585ba703ad.png";